import { render, staticRenderFns } from "./existing-board-tab.vue?vue&type=template&id=1a645124"
import script from "./existing-board-tab.vue?vue&type=script&lang=js"
export * from "./existing-board-tab.vue?vue&type=script&lang=js"
import style0 from "./existing-board-tab.vue?vue&type=style&index=0&id=1a645124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports